<div class="container-fluid" *ngIf="!countryPlaceFlag">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	<!-- <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;width:100%">
      <h5 style="float:left;"><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Manage {{this.lblHeading}}</b></h5>
    </div>
  </div> -->
	<div class="page_header">
		<h1 class="heading">Manage {{this.lblHeading}}</h1>
	</div>
	<div class="table-responsive">
		<table id="cTypes" border="1" class="table tbl-stl custom_table">

			<thead class="thead-inverse">
				<tr style="vertical-align:middle;" class="hgt-btn">
					<th class="bfr-end-col">
						Code
						<i style="vertical-align:middle; " class="fa fa-sort"
							[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
							(click)="utility.onSort(1)"></i>
					</th>
					<th style="vertical-align:middle;margin:0px;">
						Description
						<i style="vertical-align:middle;" class="fa fa-sort"
							[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
							(click)="utility.onSort(2)"></i>
					</th>
					<th style="vertical-align:middle;" class="bfr-end-col">
						ISO alpha-2
					</th>
					<th style="vertical-align:middle;" class="bfr-end-col">
						Dial Code
					</th>
					<th style="vertical-align:middle;" class="bfr-end-col">
						Active
						<i style="vertical-align:middle;" class="fa fa-sort"
							[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
							(click)="utility.onSort(3)"></i>
					</th>
					<th style="vertical-align:middle;" class="bfr-end-col">
						Sort Order
						<i style="vertical-align:middle;" class="fa fa-sort"
							[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
							(click)="utility.onSort(5)"></i>
					</th>
					<th style="vertical-align:middle;" class="bfr-end-col">
						Group
						<i style="vertical-align:middle;" class="fa fa-sort"
							[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
							(click)="utility.onSort(4)"></i>
					</th>
					<th style="vertical-align:middle;" class="bfr-end-col">Display </th>

					<!-- <th class="btn-show hgt-btn">Place</th> -->
					<th style="vertical-align:middle;" class="text-center">Place</th>
				</tr>
			</thead>
			<tr 
				*ngFor="let list of countries  | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">

				<td class="bfr-end-col">{{list.code}}</td>
				<td class="bfr-end-col">{{list.desc}}</td>
				<td class="bfr-end-col">{{list.iso_alpha2}}</td>
				<td class="bfr-end-col">{{list.dial_code}}</td>
				<td class="bfr-end-col">{{list.is_active}}</td>
				<td class="bfr-end-col">{{list.sort_order}}</td>
				<td class="bfr-end-col">{{list.group_code}}</td>
				<td class="bfr-end-col">{{utility.showDisplayIndicator(list.display_index)}}</td>
				<td class="bfr-end-col text-center">
					<i class="fa fa-map-marker map-icon" title="click here to view places"
						(click)="loadCountryDetails(list)"></i>
				</td>
			</tr>
			<tfoot>
				<tr *ngIf="countries.length > 4" class="pagination_row">
					<td colspan="9" class="rm-brd">
						<div class="row">
							<div class="col-4">
								<div class="input-group mb-3 rm-brd"
									style="width:125px!important;height:30px!important;">
									<div class="input-group-prepend">
										<label class="input-group-text form-control-sm show-h" for="show-id"
											>Show:</label>
									</div>
									<select class="form-control form-control-sm show-h" id="show-id"
										[(ngModel)]="showNum">
										<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
										</option>
									</select>
								</div>
							</div>
							<div class="col-8 text-right">
								<pagination-controls (pageChange)="utility.page = $event"></pagination-controls>
							</div>
						</div>
					</td>

				</tr>
				<tr *ngIf="countries.length==0">
					<td colspan="4" class="rm-brd">
						<span class="text-info text-small">No Countries found.</span>
					</td>
				</tr>
			</tfoot>
		</table>
	</div>

</div>
<!--
  <div class="col-md-12" *ngIf="countryPlaceFlag">
    <app-manage-country-places [list]="selectCountry"></app-manage-country-places>
  </div>
-->
